// @ts-check
import PropTypes from "prop-types"
import React, { Component } from "react"
import { getBlockByType } from "../blockTypes"

class RenderBlockAttributes extends Component {
    renderField({ attribute, value, onChange, params, style, setAttr, field, context, key }) {
        if (typeof attribute === "function") {
            attribute = attribute(params, context)
            if (!attribute) {
                // conditionnal rendering
                return null
            }
        }

        if (React.isValidElement(attribute)) {
            return React.cloneElement(attribute, {
                context: params, // deprecated
                key,
                params,
                styleContext: style, // deprecated
                style,
                setAttr,
                fieldRef: field, // deprecated
                field,
                value,
                ...attribute.props,
            })
        }

        console.log(
            "something went wrong, expected a component but got",
            typeof attribute,
            attribute
        )
        throw new Error("an error occured")
    }
    render() {
        // console.log("RenderBlockTypeAttributes.render")
        const { block, context } = this.props

        const blockType = getBlockByType(block.type)
        if (!blockType) {
            throw new Error("no blockType " + block.type)
        }
        const attributes = blockType.blockElement.attributes

        if (!attributes) {
            console.warn(`no attributes for ${block.type}`, getBlockByType(block.type).blockElement)
            throw new Error(`no attributes for ${block.type}`)
        }

        if (attributes.length === 0) {
            return ""
        }

        const renderAttribute = (attribute, id) =>
            this.renderField({
                attribute,
                value: block.config.attributes[attribute.field],
                params: block.config.attributes,
                style: block.style,
                field: block.field,
                onChange: value =>
                    context.actions.updateAttributes(block.id, attribute.field, value),
                setAttr: (field, value) => context.actions.updateAttributes(block.id, field, value),
                setStyle: (field, value) => context.actions.updateStyle(block.id, field, value),
                key: block.field || id,
                context,
            })

        if (blockType.blockElement.renderAttributes) {
            return blockType.blockElement.renderAttributes({
                attributes,
                renderAttribute,
                configuredAttributes: block.config.attributes,
            })
        }

        return attributes.map((attribute, id) => {
            return renderAttribute(attribute, id)
        })
    }
}

RenderBlockAttributes.propTypes = {
    block: PropTypes.object.isRequired,
    setAttr: PropTypes.func,
    setStyle: PropTypes.func,
}

export default RenderBlockAttributes

// remove self props to pass down to dom element
RenderBlockAttributes.cleanUpProps = ({
    context,
    params,
    styleContext,
    style,
    setAttr,
    fieldRef,
    field,
    render,
    ...otherProps
}) => otherProps



// WEBPACK FOOTER //
// ./src/features/editor/attributes/RenderBlockTypeAttributes.js